import {HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {AuthService} from './auth.service';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/do';
import {Router} from '@angular/router';

import swal from 'sweetalert2';
import {BaseService} from './base.service';
import {BroadcastService} from './broadcast.service';

@Injectable({providedIn: 'root'})
export class HttpErrorInterceptor implements HttpInterceptor {

    private refreshTokenInProgress = false;
    tokenRefreshedSource = new Subject();
    tokenRefreshed$ = this.tokenRefreshedSource.asObservable();

    constructor(private auth: AuthService, private router: Router, private service: BaseService, public broadCastService: BroadcastService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        return next.handle(request).catch(error => {
            if (error.status === 401) {
                if (localStorage.getItem('refresh_token') != null) {
                    return this.refreshAccessToken()
                        .switchMap((data: any) => {
                            request = request.clone({headers: this.service.getHeaders()});
                            return next.handle(request);
                        })
                        .catch((error2) => {
                            this.logoutAlert();
                            return Observable.throwError(error2);
                        });
                } else {
                    return Observable.throwError(error);
                }
            }
                // else if ( error.status !== 404 ) {
                //     swal( 'Error!', error.status === 0 ? 'Encountered a problem. Please try again.' : error[ 'error' ][ 'StatusMessage' ], 'error' );
                //     return Observable.throwError( error );
            // }

            else {
                this.broadCastService.error.next(error['error']['StatusMessage']);
                const errorMessage = this.prepareErrorMessage(request, error);
                if (errorMessage) {
                    swal('Error!', errorMessage, 'error');
                }

                return Observable.throwError(error);
            }

        });
    }

    refreshAccessToken(): Observable<any> {
        if (this.refreshTokenInProgress) {
            return new Observable(observer => {
                this.tokenRefreshed$.subscribe(() => {
                    observer.next();
                    observer.complete();
                });
            });
        } else {
            this.refreshTokenInProgress = true;
            return this.auth.refreshAccessToken().do(() => {
                this.refreshTokenInProgress = false;
                this.tokenRefreshedSource.next();
            });
        }
    }

    logoutAlert(): void {
        swal({
            title: 'Error!',
            text: 'Your session has timed out. Please login again.',
            type: 'warning',
            backdrop: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
            confirmButtonText: 'OK'
        })
            .then(() => {
                localStorage.removeItem('access_token');
                localStorage.removeItem('refresh_token');
                localStorage.removeItem('user');
                this.router.navigate(['auth/login']);
            })
            .catch(swal.noop);
    }

    prepareErrorMessage(request, error): string {
        if ((!request.url.includes('doctorVisit/approve')) &&
            (!request.url.includes('doctor/approve')) &&
            (!request.url.includes('api/v1/depot_stock/upload_product_stock')) &&
            (!request.url.includes('userDistanceWiseTaDaRule/upload')) &&
            (!request.url.includes('user/updateCreditLimit')) &&
            (!request.url.includes('api/chemist-incentive/upload-incentive')) &&
            (!request.url.includes('api/v1/market-product-sales-target/upload_market_product_sales_target')) &&
            (!request.url.includes('api/v1/rx/upload'))) {
            if (error['error']['StatusMessage']) {
                return error['error']['StatusMessage'];
            } else if (error['error']['errorMessages']) {
                let errors = '';
                if (error['error']['errorMessages']) {
                    error['error']['errorMessages'].forEach((pError, pIndex) => {
                        errors += pIndex + 1 + '. ' + pError + ' ';
                    });
                }
                return errors;
            } else if (error['error']['errors']) {
                let errors = '';
                if (error['error']['errors']) {
                    error['error']['errors'].forEach((pError, pIndex) => {
                        errors += pIndex + 1 + '. ' + pError + ' ';
                    });
                }
                return errors;

            } else {
                return error['message'];
            }
        }
    }
}
